/**
 * Sentences for refusals more than one screen can hit.
 *
 * Small on purpose. Copy belongs next to the thing that says it, and a shared
 * strings file is how a UI ends up written in fragments nobody can read end to
 * end. What earns a place here is a refusal the SERVER raises on several
 * routes, where two screens writing their own version means two answers to one
 * situation and only one of them getting updated.
 */

/**
 * `SESSION_NOT_FRESH`, which people will actually hit.
 *
 * Better Auth's `freshSessionMiddleware` guards `/unlink-account`, and the auth
 * service applies the same bar to `/change-email` by hand — deliberately the
 * same recency, because moving the address is at least as consequential as
 * removing a provider (RidgeWill/auth#327). Neither sets `freshAge`, so the 24h
 * default applies, and this portal is exactly the kind of tab somebody leaves
 * open for days.
 *
 * The server's own message names the endpoint's subject and does not say what
 * to do about it. This does, and it is one sentence rather than two so the two
 * screens cannot drift into disagreeing about what "fresh" means.
 *
 * `what` completes "sign in again before ___". A gerund phrase, lower case, no
 * full stop: "removing a sign-in method", "changing your email address".
 */
export function staleSessionMessage(what: string): string {
  return `For your security, sign in again before ${what}.`;
}
